var scope_0 = require('/vercel/d61e7c8/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5fb702c424987cc7d32e5146115f590a.js').default;export default
        Object.assign({}, scope_0 )
    